@if (sokningar && sokningar.length > 0) {
  <rask-tabs
    [noActiveTab]="true"
    [closable]="true"
    (onCloseTab)="confirmDeleteSparadSokning($event)"
    aid="vksokningar"
    [autoSelectNewTab]="true"
    closeIcon="far fa-trash-alt"
    closeIconColor="error"
    [useRoute]="false"
    layout="child">
    @for (sokning of sokningar; track sokning) {
      <rask-tab
        [label]="sokning.namn"
        (onTabSelected)="setSokning(sokning)"
        >
      </rask-tab>
    }
  </rask-tabs>
}